import './style.css'
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import * as dat from 'dat.gui'

gsap.registerPlugin(ScrollTrigger);

function addModelToBG() {

    //Variables for setup

    let container;
    let camera;
    let renderer;
    let scene;
    let box;

    function init() {
        /**
         * Debug
         */
        const gui = new dat.GUI( {closed: true, width: 400 })

        container = document.querySelector(".scene.one");

        //Create scene
        scene = new THREE.Scene();

        const fov = 35;
        const aspect = container.clientWidth/container.clientHeight;
        const near = 0.9;
        const far = 1000;

        //Camera setup
        camera = new THREE.PerspectiveCamera(fov, aspect, near, far);

        // Lights
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.2)
        scene.add(ambientLight)

        const directionalLight = new THREE.DirectionalLight('#ffffff', 0.8)
        directionalLight.position.set(-1.8, 2, 1.4)
        scene.add(directionalLight)

        gui.add(directionalLight, 'intensity').min(0).max(10).step(0.001).name('Light 1 strength')
        gui.add(directionalLight.position, 'x').min(- 5).max(5).step(0.001).name('light1 X')
        gui.add(directionalLight.position, 'y').min(- 5).max(5).step(0.001).name('light1 Y')
        gui.add(directionalLight.position, 'z').min(- 5).max(5).step(0.001).name('light1 Z')

        const directionalLight2 = new THREE.DirectionalLight('#ffffff', 0.8)
        directionalLight2.position.set(1.3, -1.6, -3.2)
        scene.add(directionalLight2)

        gui.add(directionalLight2, 'intensity').min(0).max(10).step(0.001).name('Light 2 strength')
        gui.add(directionalLight2.position, 'x').min(- 5).max(5).step(0.001).name('ligh2 tX')
        gui.add(directionalLight2.position, 'y').min(- 5).max(5).step(0.001).name('light2 Y')
        gui.add(directionalLight2.position, 'z').min(- 5).max(5).step(0.001).name('light2 Z')

        //Renderer
        renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });

        renderer.setSize(container.clientWidth, container.clientHeight);
        renderer.setPixelRatio(window.devicePixelRatio);

        container.appendChild(renderer.domElement);

        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('/draco/')
        const gltfLoader = new GLTFLoader()
        
        gltfLoader.setDRACOLoader(dracoLoader)
        gltfLoader.load(
            '/models/roger.glb',
            (gltf) => {                
                box = gltf.scene.children[0]
                box.scale.set(6, 6, 6, 6);
                box.position.set(0, 0, 0)                              
                scene.add(box)
                animate();            
            }
        )
    }


    function animate() {
        requestAnimationFrame(animate);      
        renderer.render(scene, camera);
    }

    init();

    function onWindowResize() {
        camera.aspect = container.clientWidth / container.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(container.clientWidth, container.clientHeight);
    }

    window.addEventListener("resize", onWindowResize);


scene.rotation.set(0, 1.88, 0)
camera.position.set(1.6, 0.3, 5)


ScrollTrigger.defaults({
  immediateRender: false,
  ease: "power1.inOut",
  scrub: true
});


    let car_anim = gsap.timeline()


    // Full Height

    car_anim.to(scene.rotation, { y: 4.79, scrollTrigger: {
  
        trigger: ".section-two",

        endTrigger: ".section-four",
        end: "top bottom",      
  
}})


    // Slide 2

    car_anim.to(camera.position, { x: -1, scrollTrigger: {
  
        trigger: ".section-two",
        
        start: "top bottom",
        end: "top top",
  
}}) 


    
    // Slide 3
    
    car_anim.to(scene.rotation, { z: 1.6, scrollTrigger: {
  
        trigger: ".section-three",

        start: "top bottom",
        end: "top top",
  
}})

    // Slide 4
    
    car_anim.to(scene.rotation, { z: 0.02, y: 3.1, scrollTrigger: {
  
        trigger: ".section-four",

        start: "top bottom",
        end: "top top",
  
}})


    car_anim.to(scene.rotation, { x: 1.3, scrollTrigger: {
  
    trigger: ".section-four",

    start: "top top",
    end: "bottom top",

}})

    
    car_anim.to(camera.position, { x: -1, scrollTrigger: {
  
        trigger: ".section-four",

        start: "top top",
        end: "bottom top",
  
}})


}
addModelToBG();

